import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { cloneDeep, cloneDeepWith, first } from "lodash";
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../common_components/mdae-framework";
import { GET_USER_TASK_LIST } from "../services/get-user-task-list";
import { GET_USER_TASK_DATASOURCE } from "../services/get-user-task-datasource";
import { GET_USER_TASK_STATUS_LIST } from "../services/get-user-task-status-list";
import { GET_AUDITOR_LIST } from "../services/get-auditor-list";
import { GET_ATTACHMENT_LEVEL_LIST } from "../services/get-attachment-level-list";
import { USER_TASK_POPUP_MODE } from "../component";
import { GET_USER_TASK_LIST_BY_LEVEL } from "../services/get-user-task-list-by-level";
import { GET_ACTIVE_USERS_LIST } from "../services/get-active-users-list";
import { GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION } from "../services/get-external-user-group-list-with-association";
import { GET_TASK_GROUP_LIST_WITH_ASSOCIATION } from "../services/get-task-group-list-with-association";
import { defaultCompletedAndCanceledTabData } from "../../../pages/my-tasks/reducers/my-tasks-page-reducer";
export const TOGGLE_USER_TASK_LIST_POPOVER = "TOGGLE_USER_TASK_LIST_POPOVER";
export const SET_USER_TASK_ATTACHED_LEVEL_ENUMS =
  "SET_USER_TASK_ATTACHED_LEVEL_ENUMS";
export const SET_USER_TASK_GRID_CHECKBOXES = "SET_USER_TASK_GRID_CHECKBOXES";
export const TOGGLE_USER_TASK_SELECT_ALL_FLAG =
  "TOGGLE_USER_TASK_SELECT_ALL_FLAG";
export const SET_CURRENT_USER_ACTION_MODE = "SET_CURRENT_USER_ACTION_MODE";
export const SET_USER_TASK_POPUP_MODE = "SET_USER_TASK_POPUP_MODE";
export const SET_USER_TASK_FORM_DATA = "SET_USER_TASK_FORM_DATA";
export const TOGGLE_ADD_USER_TASK_POPUP = "TOGGLE_ADD_USER_TASK_POPUP";
export const TOGGLE_BULK_EDIT_USER_TASK_POPUP =
  "TOGGLE_BULK_EDIT_USER_TASK_POPUP";
export const SET_USER_TASK_SELECTED_ROWS_DATA =
  "SET_USER_TASK_SELECTED_ROWS_DATA";
export const SET_USER_TASK_BULK_EDIT_DATA = "SET_USER_TASK_BULK_EDIT_DATA";
export const SET_BULK_EDIT_USER_TASK_POPUP_MODE =
  "SET_BULK_EDIT_USER_TASK_POPUP_MODE";
export const SET_USER_TASK_SELECTED_INDEX = "SET_USER_TASK_SELECTED_INDEX";
export const SET_USER_TASK_CHART_SELECTED_INDEX =
  "SET_USER_TASK_CHART_SELECTED_INDEX";
export const SET_USER_TASK_LIST_DATAGRID_FILTER =
  "SET_USER_TASK_LIST_DATAGRID_FILTER";
export const SET_USER_TASK_CHART_DATASOURCE = "SET_USER_TASK_CHART_DATASOURCE";
export const TOGGLE_FILTER_VALUE = "TOGGLE_FILTER_VALUE";
export const SET_USER_TASK_CHART_BUTTON_VALUE =
  "SET_USER_TASK_CHART_BUTTON_VALUE";
export const SET_USER_TASK_CHART_ICON_VALUE = "SET_USER_TASK_CHART_ICON_VALUE";
export const RESET_ADD_NEW_TASK_POPUP_VALIDATION =
  "RESET_ADD_NEW_TASK_POPUP_VALIDATION";
export const SET_CURRENT_ATTACHED_LEVEL_DATA =
  "SET_CURRENT_ATTACHED_LEVEL_DATA";
export const SET_REF_TASK_LIST_DATASOURCE = "SET_REF_TASK_LIST_DATASOURCE";
export const TOGGLE_ASSIGNED_TO_WIDGET = "TOGGLE_ASSIGNED_TO_WIDGET";
export const SET_INCLUDE_NON_LEVELCHECKBOX_VALUE =
  "SET_INCLUDE_NON_LEVELCHECKBOX_VALUE";
export const SET_USER_TASK_DATASOURCE_VALUES =
  "SET_USER_TASK_DATASOURCE_VALUES";
export const TOGGLE_SELECT_EXTERNAL_USER_POPUP =
  "TOGGLE_SELECT_EXTERNAL_USER_POPUP";
export const SET_POPUP_OPENED_FROM_COMPLETED_BY =
  "SET_POPUP_OPENED_FROM_COMPLETED_BY";
export const SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT =
  "SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT";
export const TOGGLE_COMPLETE_TASK_TOAST = "TOGGLE_COMPLETE_TASK_TOAST";
export const SET_GRID_COMPLETE_CHECKBOX_CLICKED =
  "SET_GRID_COMPLETE_CHECKBOX_CLICKED";
export const SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW =
  "SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW";
export const SET_TASK_LIST_GRID_SETTING = "SET_TASK_LIST_GRID_SETTING";
export const TOGGLE_SELECT_ASSIGNED_GROUP_USER_POPUP =
  "TOGGLE_SELECT_ASSIGNED_GROUP_USER_POPUP";
export const SET_ASSIGNED_USER_TYPE = "SET_ASSIGNED_USER_TYPE";
export const SET_SELECT_GROUP_DATAGRID_INSTANCE =
  "SET_SELECT_GROUP_DATAGRID_INSTANCE";
export const SET_CURRENT_SELECTED_GROUP_ROW_DATA =
  "SET_CURRENT_SELECTED_GROUP_ROW_DATA";
export const SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP =
  "SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP";
export const SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA =
  "SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA";
  export const SET_USER_TASK_SELECTED_COUNT ='SET_USER_TASK_SELECTED_COUNT';
export const TOGGLE_TASK_HISTORY_POPUP="TOGGLE_TASK_HISTORY_POPUP";
const initialError = {
  code: "",
  message: "",
  value: [],
};

export const defaultUserTaskFormData = {
  userTaskId: 0,
  attachedLevelName: null,
  level: "EA",
  dueDate: null,
  assignedToUserId: 0,
  refTaskId: null,
  refTaskName: null,
  statusId: null,
  scheduledDateString: "",
  scheduleTime: "",
  scheduledDate: null,
  auditorNotes: "",
  schedulingNotes: "",
  managerNotes: "",
  completionDate: null,
  completedByUsedId: null,
  attachedLevelId: 0,
  userTaskEditPropertyInd: false,
  totalTime: 0,
  auditId: 0,
  completeInd: false,
  createdBy: "",
  updatedBy: "",
  createDate: null,
  updateDate: null,
  isAssignedToExternalUser: false,
  isCompletedByExternalUser: false,
  externalNotes: "",
  isAccountToggleEnabled: false,
  isMRNToggleEnabled:false,
  assignedUserType:""
};
export const defaultBulkEditUserTaskData = {
  assignedToUserId: 0,
  statusId: 0,
  completionDate: null,
  completedByUsedId: 0,
  scheduleTime: "",
  scheduledDate: null,
  scheduledDateString: "",
};
export const userTaskGridSelection = {
  mode: "single",
  showCheckBoxesMode: "always",
  selectAllMode: "allPages",
};
export const userTaskLevels = {
  Audit:'AU',
  Case:'AC',
  Entity:'AE',
  Coder:'CO',
  CoderGroup:'CG',
  Provider:'PR',
  RenderingProviderGroup:'RPG',
  Facility:'FC',
  PayerAudit:'EA',
  PayerAuditCase:'EAC'
};
const initialState = {
  loading: false,
  error: initialError,
  attachLevelEnums: {},
  userTaskList: [],
  currentUserId: 0,
  userTaskGridSelection,
  userLevelNameList: [],
  userTaskListFiltered: [],
  refTaskList: [],
  userTaskFormData: { ...defaultUserTaskFormData },
  initialUserTaskFormData: { ...defaultUserTaskFormData },
  currentSelectedRowsData: [],
  userTaskAttachmentLevels: [],
  defaultStatusValue: 0,
  completedStatusValue: 0,
  userTaskStatusList: [],
  defaultPreviousStatusValue: 0,
  auditorList: [],
  userTaskBulkEditData: defaultBulkEditUserTaskData,
  userTaskChartSelectedIndex: 0,
  isChartCollapsible: false,
  userTaskListDataGridFilter: [],
  userTaskChartDataSource: {},
  userTaskChartButton: "Hide Charts",
  userTaskChartIcon: "fas fa-caret-down",
  isUserTaskListDataGridActionPopoverVisible: false,
  isFilterValueChange: true,
  currentAttachedLevelId: null,
  currentAttachedLevelName: "",
  userEaTaskAttachmentLevels: [],
  isAssignedToDisabled: false,
  includeNonAttachedLevelTasks: false,
  isCompleteTaskToastVisible: false,
  isOpenedFromCardView: false,
  isMaintenanceLevelTask: false,
  isGetGridSettingCalled: false,
  externalUserGroupListWithAssociation: [],
  taskGroupListWithAssociation: [],
  completedAndCanceledTabData:{...defaultCompletedAndCanceledTabData},
  selectedTasksCount:0,
  assignedToUserList:[],
  isTaskHistoryPopupVisible:false
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_USER_TASK_DATASOURCE_VALUES:
      return { ...state, ...action.data };
    case SET_USER_TASK_SELECTED_COUNT:
      return { ...state, ...action.data };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      //get user task list
      if (isAsyncOperation(GET_USER_TASK_LIST)(action)) {
        return {
          ...state,
          userTaskList: [],
          attachLevelEnums: {},
          currentUserId: 0,
        };
      }
      if (isAsyncComplete(GET_USER_TASK_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          userTaskList: response.userTaskList,
          attachLevelEnums: userTaskLevels,
          currentUserId: response.currentUserId,
          loading: false,
        };
      }
      if (isAsyncFailure(GET_USER_TASK_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get user task list by Level
      if (isAsyncOperation(GET_USER_TASK_LIST_BY_LEVEL)(action)) {

        return { ...state, ["userTaskList" + (first<any>(action.args).taskDataPrefix ?? "")]: [] };
      }
      if (isAsyncComplete(GET_USER_TASK_LIST_BY_LEVEL)(action)) {
        const response = action.response;
        return {
          ...state,
          ["userTaskList" + (first<any>(action.args).taskDataPrefix ?? "")]: response.userTaskList,
          loading: false,
        };
      }
      if (isAsyncFailure(GET_USER_TASK_LIST_BY_LEVEL)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get user task datasource
      if (isAsyncOperation(GET_USER_TASK_DATASOURCE)(action)) {
        return {
          ...state,
          userLevelNameList: [],
          userTaskListFiltered: [],
          refTaskList: [],
          assignedToUserList: [],
        };
      }
      if (isAsyncComplete(GET_USER_TASK_DATASOURCE)(action)) {
        const response = action.response;
        return {
          ...state,
          userLevelNameList: response.userLevelNameList,
          userTaskListFiltered: response.userTaskList,
          refTaskList: response.refTaskList,
          assignedToUserList: response.assignedToUserList,
          loading: false,
        };
      }
      if (isAsyncFailure(GET_USER_TASK_DATASOURCE)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get user task status list
      if (isAsyncOperation(GET_USER_TASK_STATUS_LIST)(action)) {
        return {
          ...state,
          userTaskStatusList: [],
          defaultPreviousStatusValue: 0,
        };
      }
      if (isAsyncComplete(GET_USER_TASK_STATUS_LIST)(action)) {
        const response = action.response;
        const defaultPreviousStatus = response.find(
          (e) =>
            e.statusType == "In-Progress" &&
            e.statusCd == "In-Progress" &&
            e.curated == "Y"
        );
        return {
          ...state,
          userTaskStatusList: response,
          defaultPreviousStatusValue: defaultPreviousStatus.statusId,
          loading: false,
        };
      }
      if (isAsyncFailure(GET_USER_TASK_STATUS_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get auditor list
      if (isAsyncOperation(GET_AUDITOR_LIST)(action)) {
        return { ...state, auditorList: [] };
      }
      if (isAsyncComplete(GET_AUDITOR_LIST)(action)) {
        const response = action.response;
        return { ...state, auditorList: response, loading: false };
      }
      if (isAsyncFailure(GET_AUDITOR_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get attachment level list
      if (isAsyncOperation(GET_ATTACHMENT_LEVEL_LIST)(action)) {
        return { ...state };
      }
      if (isAsyncComplete(GET_ATTACHMENT_LEVEL_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          currentUserId: response.userId,
          userTaskAttachmentLevels: response.userTaskAttachmentLevels,
          defaultStatusValue: response.defaultStatusValue[0].statusId,
          completedStatusValue: response.completedStatusValue[0].statusId,
          userEaTaskAttachmentLevels: response.userEaTaskAttachmentLevels,
          attachLevelEnums: response.userTaskLevels[0],
          loading: false,
        };
      }
      if (isAsyncFailure(GET_ATTACHMENT_LEVEL_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      if (isAsyncComplete(GET_ACTIVE_USERS_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          assignedToUserList: response.activeUsers,
        };
      }
      if (
        isAsyncOperation(GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION)(action)
      ) {
        return { ...state, externalUserGroupListWithAssociation: [] };
      }
      if (
        isAsyncComplete(GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION)(action)
      ) {
        const response = action.response;
        return {
          ...state,
          externalUserGroupListWithAssociation: response.externalUserGroupList,
        };
      }
      if (isAsyncOperation(GET_TASK_GROUP_LIST_WITH_ASSOCIATION)(action)) {
        return { ...state, taskGroupListWithAssociation: [] };
      }
      if (isAsyncComplete(GET_TASK_GROUP_LIST_WITH_ASSOCIATION)(action)) {
        const response = action.response;
        return {
          ...state,
          taskGroupListWithAssociation: response.taskGroupList,
        };
      }
      return state;
    case SET_USER_TASK_CHART_SELECTED_INDEX:
      return {
        ...state,
        userTaskChartSelectedIndex: action.data.userTaskChartSelectedIndex,
      };
    case RESET_ADD_NEW_TASK_POPUP_VALIDATION:
    case SET_USER_TASK_GRID_CHECKBOXES:
    case TOGGLE_USER_TASK_LIST_POPOVER:
    case SET_USER_TASK_ATTACHED_LEVEL_ENUMS:
    case TOGGLE_TASK_HISTORY_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;

    case SET_CURRENT_USER_ACTION_MODE:
      return { ...state, currentUserActionMode: action.currentUserActionMode };
    case SET_USER_TASK_POPUP_MODE:
      return { ...state, userTaskPopupMode: action.userTaskPopupMode };
    case SET_BULK_EDIT_USER_TASK_POPUP_MODE:
      return {
        ...state,
        bulkEditUserTaskPopupMode: action.data.bulkEditUserTaskPopupMode,
      };
    case SET_USER_TASK_SELECTED_INDEX:
      return {
        ...state,
        userTaskSelectedIndex: action.data.userTaskSelectedIndex,
      };
    case SET_INCLUDE_NON_LEVELCHECKBOX_VALUE:
    case TOGGLE_ASSIGNED_TO_WIDGET:
    case SET_CURRENT_ATTACHED_LEVEL_DATA:
    case SET_USER_TASK_LIST_DATAGRID_FILTER:
    case TOGGLE_FILTER_VALUE:
    case SET_USER_TASK_CHART_DATASOURCE:
    case TOGGLE_BULK_EDIT_USER_TASK_POPUP:
    case TOGGLE_ADD_USER_TASK_POPUP:
    case TOGGLE_SELECT_EXTERNAL_USER_POPUP:
    case TOGGLE_SELECT_ASSIGNED_GROUP_USER_POPUP:
    case SET_ASSIGNED_USER_TYPE:
    case SET_SELECT_GROUP_DATAGRID_INSTANCE:
    case SET_CURRENT_SELECTED_GROUP_ROW_DATA:
    case SET_POPUP_OPENED_FROM_COMPLETED_BY:
    case SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT:
    case TOGGLE_COMPLETE_TASK_TOAST:
    case SET_GRID_COMPLETE_CHECKBOX_CLICKED:
    case SET_USER_TASK_POPUP_OPENED_FROM_CARD_VIEW:
    case SET_TASK_LIST_GRID_SETTING:
    case SET_SELECTED_BULK_TASK_ASSIGNED_TO_GROUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_USER_TASK_BULK_EDIT_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const userTaskBulkEditData = newState.userTaskBulkEditData
          ? cloneDeep(newState.userTaskBulkEditData)
          : {};
        for (let prop in action.data.userTaskBulkEditData) {
          userTaskBulkEditData[prop] = action.data.userTaskBulkEditData[prop];
        }
        userTaskBulkEditData.scheduleTime = getScheduleTime(
          userTaskBulkEditData
        );
        userTaskBulkEditData.scheduledDate = getScheduleDate(
          userTaskBulkEditData
        );
        newState = {
          ...newState,
          userTaskFormData: userTaskBulkEditData,
          userTaskBulkEditData,
        };
      }
      return newState;
    case SET_USER_TASK_FORM_DATA:
      newState = {...state};
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const tempUserTaskFormData = {
          ...newState.userTaskFormData,
          ...action.data.userTaskFormData,
        }
        const scheduleTime = getScheduleTime(tempUserTaskFormData);
        const scheduledDate = getScheduleDate(tempUserTaskFormData); 
        const refTaskName = newState.refTaskList?.filter(
          (x) => x.refTaskId == action.data?.userTaskFormData?.refTaskId
        )[0]?.refTaskName || newState?.userTaskFormData?.refTaskName || action.data?.userTaskFormData?.refTaskName;
        return {
          ...newState,
          userTaskFormData: {
            ...newState.userTaskFormData,
            ...action.data.userTaskFormData,
            scheduleTime,
            scheduledDate,
            refTaskName
          },
          initialTaskData: { ...newState.initialTaskData, ...action.data.initialTaskData },
        }
      }
      return newState;
    case SET_USER_TASK_SELECTED_ROWS_DATA:
      return {
        ...state,
        currentSelectedRowsData: action.data.currentSelectedRowsData,
      };
    case SET_USER_TASK_CHART_BUTTON_VALUE:
      return { ...state, userTaskChartButton: action.data.userTaskChartButton };
    case SET_USER_TASK_CHART_ICON_VALUE:
      return { ...state, userTaskChartIcon: action.data.userTaskChartIcon };
      case SET_TASK_HQ_COMPLETED_AND_CANCELED_TAB_DATA:
        newState = cloneDeep(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          const completedAndCanceledTabData = newState.completedAndCanceledTabData
            ? newState.completedAndCanceledTabData
            : {};
          for (let prop in action.data.completedAndCanceledTabData) {
            completedAndCanceledTabData[prop] =
              action.data.completedAndCanceledTabData[prop];
          }
          newState = {
            ...newState,
            completedAndCanceledTabData,
          };
        }
        return newState;
    case SET_REF_TASK_LIST_DATASOURCE:
      newState = cloneDeep(state);
      var templateList = cloneDeep(newState.refTaskList);
      var requiredTemplateList = [];
      for (var i of templateList) {
        if (i.attachedLevel == "EAC" || i.attachedLevel == "EA") {
          requiredTemplateList.push(i);
        }
      }
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        var refTaskDataSource = [];
        if (action.data.userTaskFormData && newState.userTaskPopupMode == USER_TASK_POPUP_MODE.EDIT) {
          refTaskDataSource.push({
            refTaskId: action.data.userTaskFormData.refTaskId,
            refTaskName: action.data.userTaskFormData.refTaskName,
            dueDate: action.data.userTaskFormData.dueDate,
            assignedToUserId: action.data.userTaskFormData.assignedToUserId,
            statusId: action.data.userTaskFormData.statusId,
            hasAssignedToUserId:
              action.data.userTaskFormData.hasAssignedToUserId,
            isAssignedToExternalUser:
              action.data.userTaskFormData.isAssignedToExternalUser,
            assignedToUserType: action.data.userTaskFormData.assignedUserType,
          });
        } else {
          if (action.data.filterBy == "Level") {
            var filteredRefTaskList = getTaskListDataSourceOnLevel(
              newState.userTaskFormData,
              newState.currentAttachedLevelName,
              requiredTemplateList,
              newState.userTaskList
            );
            for (var item of filteredRefTaskList) {
              refTaskDataSource.push(item);
            }
          } else if (action.data.filterBy == "LevelName") {
            var filteredRefTaskList = getTaskListDataSourceOnLevelName(
              newState.userTaskFormData,
              newState.currentAttachedLevelName,
              requiredTemplateList,
              newState.userTaskList
            );
            for (var item of filteredRefTaskList) {
              refTaskDataSource.push(item);
            }
          }
        }
      }
      return { ...state, refTaskDataSource: refTaskDataSource };
    default:
      return state;
  }
};

const getScheduleTime = (data) => {
  if (data.scheduleTime || data.scheduledDate) {
    const dateTimeField = data.scheduleTime ? data.scheduleTime : data.scheduledDate;
    var scheduleTime =
      new Date(dateTimeField).getHours() +
      ":" +
      new Date(dateTimeField).getMinutes();
    if (scheduleTime != "0:0") return dateTimeField;
  }
};
const getScheduleDate = (data) => {
  var scheduleDate = new Date(data.scheduledDate).toLocaleDateString();
  if (new Date(scheduleDate).getTime() != new Date("1/1/1900").getTime()) {
    return data.scheduledDate;
  }
};
export const formatUserTaskObjectToSave = (
  data,
  currentAttachedLevelId = 0,
  currentAttachedLevelName = "",
  userTaskPopupMode = USER_TASK_POPUP_MODE.EDIT,
  userTaskLevelNameList = []
) => {
  var userTaskScheduleDate = data.scheduledDate;
  var userTaskScheduleTime = data.scheduleTime;
  if (userTaskScheduleDate && userTaskScheduleTime) {
    var userTaskScheduleDateTimeString =
      new Date(userTaskScheduleDate).toLocaleDateString() +
      " " +
      new Date(userTaskScheduleTime).getHours() +
      ":" +
      new Date(userTaskScheduleTime).getMinutes();
    data.scheduledDateString = userTaskScheduleDateTimeString;
  } else if (userTaskScheduleDate) {
    data.scheduledDateString = new Date(
      userTaskScheduleDate
    ).toLocaleDateString();
  } else if (userTaskScheduleTime) {
    data.scheduledDateString =
      new Date(userTaskScheduleTime).getHours() +
      ":" +
      new Date(userTaskScheduleTime).getMinutes();
  } else {
    data.scheduledDateString = null;
  }
  if (data.scheduledDateString) {
    const parsed = new Date(data.scheduledDateString);
    if (!isNaN(parsed.getTime())) {
      const yyyy = parsed.getFullYear();
      const mm = String(parsed.getMonth() + 1).padStart(2, '0');
      const dd = String(parsed.getDate()).padStart(2, '0');
      const hh = String(parsed.getHours()).padStart(2, '0');
      const mi = String(parsed.getMinutes()).padStart(2, '0');
      const ss = String(parsed.getSeconds()).padStart(2, '0');
  
      data.scheduledDate = `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
    }
  }
  if (userTaskPopupMode === USER_TASK_POPUP_MODE.ADD) {
    if (currentAttachedLevelName == "EA") {
      data.attachedLevel = data.level;
      data.attachedLevelName = data.level;
      data.attachedLevelId =
        data.level == "EA" ? currentAttachedLevelId : data.attachedLevelId;
      if (data.level?.toUpperCase() === "EAC" && data.attachedLevelId === -1) {
        data.attachedLevelIdList = userTaskLevelNameList
          .filter((x) => x.attachedLevelId > 0)
          .map((x) => x.attachedLevelId);
      }
    } else if (currentAttachedLevelName == "EAC") {
      data.attachedLevel = currentAttachedLevelName;
      data.attachedLevelName = currentAttachedLevelName;
      data.attachedLevelId = currentAttachedLevelId;
    }
    data.lastReminderSentByUserId=null;
    data.lastReminderSentDate=null;
  }
  data.statusUpdateDate = new Date();
  delete data.createDate;
  delete data.updateDate;
  return data;
};

export const formatTaskListForBulkUpdate = (userTaskBulkEditData, usserTaskList: any[]) => {
  return usserTaskList.map((task) => {
    task = {
      ...task,
      assignedToUserId:userTaskBulkEditData.assignedToUserId,
      statusId: userTaskBulkEditData.statusId,
      completionDate: userTaskBulkEditData.completionDate,
      completedByUsedId: userTaskBulkEditData.completedByUsedId,
      scheduledDate: userTaskBulkEditData.scheduledDate,
      scheduleTime: userTaskBulkEditData.scheduleTime,
      assignedUserType:userTaskBulkEditData.assignedUserType,
      isAssignedToChanged:userTaskBulkEditData.assignedToUserId !=0 && userTaskBulkEditData.assignedToUserId !=task.assignedToUserId
    }
    return formatUserTaskObjectToSave(task)
  });
} 

export const getTaskListDataSourceOnLevel = (
  userTaskFormData,
  currentAttachedLevelName,
  refTaskList,
  userTaskList
) => {
  var userRefTaskLevelList = [];
  var userTaskTemplateList = [];
  const userTaskSelectedLevel =
    currentAttachedLevelName != "EA"
      ? currentAttachedLevelName
      : userTaskFormData.level;
  if (currentAttachedLevelName != "EA" || userTaskFormData.level == "EA") {
    for (const refTask of refTaskList) {
      if (!refTask.allowDuplicateInd) {
        const isContainId = userTaskList.some(
          (item) => item.refTaskId == refTask.refTaskId
        );
        if (!isContainId) userRefTaskLevelList.push(refTask);
      } else userRefTaskLevelList.push(refTask);
    }
    for (const item of userRefTaskLevelList) {
      if (item.attachedLevel == userTaskSelectedLevel)
        userTaskTemplateList.push(item);
    }
  }
  return userTaskTemplateList;
};
export const getTaskListDataSourceOnLevelName = (
  userTaskFormData,
  currentAttachedLevelName,
  refTaskList,
  userTaskList
) => {
  var userRefTaskLevelList = [];
  var userTaskTemplateList = [];
  var isContainsId = false;
  if (userTaskFormData.attachedLevelId && userTaskFormData.level != "EA") {
    if (userTaskList.length > 0) {
      for (const value of refTaskList) {
        if (!value.allowDuplicateInd) {
          const isContainId = userTaskList.some(
            (item) => item.refTaskId == value.refTaskId
          );
          if (!isContainId) userRefTaskLevelList.push(value);
          else {
            for (const item of userTaskList) {
              if (
                value.refTaskId == item.refTaskId &&
                userTaskFormData.attachedLevelId == item.attachedLevelId
              ) {
                isContainsId = true;
              }
            }
            if (!isContainsId) userRefTaskLevelList.push(value);
            isContainsId = false;
          }
        } else userRefTaskLevelList.push(value);
      }
    } else {
      for (const i of refTaskList) {
        userRefTaskLevelList.push(i);
      }
    }
    for (const item of userRefTaskLevelList) {
      if (item.attachedLevel == userTaskFormData.level)
        userTaskTemplateList.push(item);
    }
  }
  return userTaskTemplateList;
};
